import React from 'react';
import { useNavigate } from 'react-router-dom';
import ForgotPassword from '../components/ForgotPassword/ForgotPassword';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const goToSignIn = () => navigate('/signin', { replace: true });

  return <ForgotPassword onClose={goToSignIn} />;
}
